module.exports = __webpack_public_path__ + "img/icon_filter.9215b559.svg";